// src/telas/pracas/index.tsx

import { Menu } from "../menu";
import styles from "./styles.module.css";
import { useContext, useEffect, useState } from "react";
import { AuthFetchJson, url } from "../../api";
import Swal from "sweetalert2";
import { ContextRegister } from "../../context";
import { useNavigate } from "react-router-dom";

type PracaType = {
  ZD_CODIGO?: string;
  ZD_DESCR: string;
  checked?: boolean;
  ZD_EST?: string;
};

export function Pracas() {
  const { state } = useContext(ContextRegister);
  const navigate = useNavigate();
  const [minhasPracas, setMinhasPracas] = useState<PracaType[]>([]);
  const [pracas, setPracas] = useState<PracaType[]>([]);
  const [termo, setTermo] = useState("");

  function buscarMinasPracas() {
    AuthFetchJson(`${url}COLETAPRACAPARCEIRO`, {
      method: "POST",
      body: JSON.stringify({
        CODPAR: state.usuario.A2_COD,
        LOJA: state.usuario.A2_LOJA,
      }),
    })
      .then((response) => {
        if (response.sucesso !== "T") {
          Swal.fire("Erro ao buscar praças associadas.");
          return;
        }
        setMinhasPracas(
          response.dados.map((p: any) => ({
            ZD_CODIGO: p.PRACA,
            ZD_DESCR: p.DESCRICAO,
            checked: true,
          })),
        );
      })
      .catch((error) => {
        Swal.fire("Erro ao buscar praças associadas.");
        console.log(error);
      })
      .finally(() => {
        if (Swal.isLoading()) Swal.close();
      });
  }

  function handleCheckIns(index: number, obj: PracaType) {
    let aux = [...pracas];
    index = aux.findIndex((a) => a.ZD_CODIGO === obj.ZD_CODIGO);
    aux.splice(index, 1, { ...obj, checked: !obj.checked });
    setPracas(aux);
  }

  function handleSave() {
    Swal.fire({
      title: "Salvando",
      html: "Aguarde, gravando dados de praças",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let pracaSave = pracas
      .filter((praca) => praca.checked)
      .map((praca) => ({ praca: praca.ZD_CODIGO }));

    AuthFetchJson(`${url}PRACAPARCEIRO`, {
      method: "POST",
      body: JSON.stringify({
        CODPAR: state.usuario.A2_COD,
        LOJA: state.usuario.A2_LOJA,
        itens: pracaSave,
      }),
    }).finally(() => {
      if (Swal.isLoading()) Swal.close();
    });
  }

  useEffect(() => {
    Swal.fire({
      title: "Carregando",
      html: "Carregando praças cadastradas",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    AuthFetchJson(`${url}COLETAPRACA/${state.usuario.A2_EST}`)
      .then((response) => {
        if (response.sucesso !== "T") {
          Swal.fire("Erro ao buscar praças");
          return;
        }
        setPracas(
          response.dados.map((praca: any) => ({
            ZD_CODIGO: praca.ZD_CODIGO,
            ZD_DESCR: praca.ZD_DESCR,
            ZD_EST: praca.ZD_EST,
            checked: false,
          })),
        );
        buscarMinasPracas();
      })
      .catch((error) => {
        Swal.fire("Erro ao buscar praças");
        console.log(error);
      })
      .finally(() => {
        if (Swal.isLoading()) Swal.close();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pracas.length === 0 || minhasPracas.length === 0) return;

    let pracasInter = pracas.map((praca) => {
      if (minhasPracas?.some((i) => i.ZD_CODIGO === praca.ZD_CODIGO)) {
        return { ...praca, checked: true };
      }
      return praca;
    });

    setPracas(pracasInter);
  }, [minhasPracas]); // eslint-disable-line react-hooks/exhaustive-deps

  const pracasFiltradas = pracas.filter(
    (praca) =>
      praca.ZD_DESCR.toUpperCase().search(`${termo}`.toUpperCase()) !== -1,
  );

  const totalSelecionados = pracas.filter((p) => p.checked).length;

  return (
    <div className={styles.container}>
      <Menu />

      <div className={styles.backContainer}>
        <p onClick={() => navigate(-1)}>{"< Voltar"}</p>
      </div>

      <div className={styles.content}>
        <div className={styles.insumoContainer}>
          <div className={styles.insumoHeader}>
            <h2>Praças</h2>
            {totalSelecionados > 0 && (
              <span className={styles.badge}>{totalSelecionados} selecionada(s)</span>
            )}
            <button className={styles.btnSalvar} onClick={handleSave}>
              Salvar
            </button>
          </div>

          <input
            className={styles.searchInput}
            placeholder="Pesquisar praça..."
            type="text"
            value={termo}
            onChange={(event) => setTermo(event.target.value)}
          />

          <div className={styles.insumosOverflow}>
            {pracasFiltradas.length === 0 ? (
              <p className={styles.emptyText}>Nenhuma praça encontrada.</p>
            ) : (
              pracasFiltradas.map((praca, index) => (
                <label
                  key={praca.ZD_CODIGO}
                  className={`${styles.insumoItem} ${praca.checked ? styles.insumoItemChecked : ""}`}
                >
                  <input
                    type="checkbox"
                    onChange={() => handleCheckIns(index, praca)}
                    value={praca.ZD_DESCR}
                    checked={praca.checked}
                  />
                  <span>{praca.ZD_DESCR}</span>
                </label>
              ))
            )}
          </div>

          <div className={styles.listFooter}>
            <span>{pracasFiltradas.length} praça(s)</span>
          </div>
        </div>
      </div>
    </div>
  );
}